<script setup lang="ts">
// Tela "Informe Rendimentos" do Minha Conta V2 (ENG-362).
// Figma: mobile 19771:42087 / desktop 19771:52498. Consulta externa
// compartilhada com a página antiga (pages/user/irpf-rendimentos.vue) via
// useIrpfReport(): monta a URL do portal de informe (brand AT) com CPF +
// data de nascimento e abre em nova aba ("redirecionado para a página de
// consulta", como diz o texto do design).
const { t } = useTexts();
const { fetchUserProfile } = useUserData();

// paridade com o menu antigo (condition: isIrpfEnabled): sem a permissão a
// tela não fica acessível. O menu já esconde o item; cobre deep-link direto.
const { isIrpfEnabled } = useFeatureFlagsEnv();
const { close } = useUserV2Modal();

watchEffect(() => {
  if (!isIrpfEnabled.value) close();
});

const { reportYear, hasRequiredData, handleDownload } = useIrpfReport();

onBeforeMount(() => {
  if (!hasRequiredData.value) {
    fetchUserProfile({ force: true });
  }
});
</script>

<template>
  <div class="flex flex-col gap-[8px] rounded-[10px] bg-v2-default/40 p-[12px]">
    <div class="flex h-[36px] items-center">
      <p class="text-[14px] font-medium leading-[20px] text-white">
        {{ t('income_report_external.heading') }}
      </p>
    </div>

    <p class="text-[12px] leading-[16px] text-v2-default-900">
      {{ t('income_report_external.description', { year: reportYear }) }}
    </p>

    <div class="border-solid w-full border-t border-white/10"></div>

    <p
      v-if="!hasRequiredData"
      class="rounded-[12px] bg-v2-danger/20 p-[12px] text-[12px] leading-[16px] text-v2-danger"
    >
      {{ t('income_report_external.incomplete_data') }}
    </p>

    <button
      class="flex h-[40px] w-full items-center justify-center gap-[8px] rounded-[12px] bg-v2-primary px-[16px] text-[14px] leading-[20px] text-v2-default-900 disabled:cursor-not-allowed disabled:opacity-50"
      :disabled="!hasRequiredData"
      type="button"
      @click="handleDownload"
    >
      <UserV2Icon name="income" />
      {{ t('income_report_external.download_button') }}
    </button>
  </div>
</template>
